import Animated from 'components/animations';
import { MainMenu, TextSelect } from 'components/molecules';
import { TextSelectOptionProps } from 'components/molecules/TextSelect/types';
import { LocaleProps } from 'contexts/language';
import React from 'react';
import { useState } from 'react';
import classNames from 'classnames';
import { Container } from 'components/atoms';

interface Props {
  locale: LocaleProps;
  sections: { about: string; projects: string; blogs: string; skills: string; contact: string };
  className?: string;
}

export default function Navigation({ locale, sections, className }: Props) {
  const [animationFinish, setAnimationFinish] = useState(false);
  const languageOptions: TextSelectOptionProps[] = [
    { label: 'English', value: 'en' },
    { label: 'Français', value: 'fr' },
    { label: 'Deutsch', value: 'de' },
    { label: '中文', value: 'zh' },
    { label: '日本語', value: 'ja' },
    { label: 'Indonesia', value: 'id' },
  ];

  const selectedLanguage =
    languageOptions.find(option => option.value === locale.value) || languageOptions[0];

  const setSelectedLanguage = (option: TextSelectOptionProps) => {
    if (['en', 'id', 'fr', 'de', 'ja', 'zh'].includes(option.value as string)) {
      locale.change(option.value as any);
    }
  };

  return (
    <nav>
      <Animated.FromDirection
        from="top"
        className={classNames('w-full', className)}
        duration={1}
        onAnimationComplete={() => setAnimationFinish(true)}
      >
        <Container className="flex">
          <div className="flex self-center flex-1 pr-8">
            <div className="sm:ml-auto">
              <TextSelect
                state={[selectedLanguage, setSelectedLanguage]}
                options={languageOptions}
              />
            </div>
          </div>
          <MainMenu sections={sections} animationFinish={animationFinish} />
        </Container>
      </Animated.FromDirection>
    </nav>
  );
}
